import { Component, OnInit, ViewChild, ElementRef } from '@angular/core'
import { AdminSmtpSettings } from '@parkupp/core'
import { ProspectingService } from 'src/app/services/prospecting.service'
import { AuthenticationService } from 'src/app/services/authentication.service'

@Component({
    selector: 'app-admin-profile',
    templateUrl: './admin-profile.component.html',
    styleUrls: ['./admin-profile.component.scss'],
})
export class AdminProfileComponent implements OnInit {
    userName = ''
    userEmail = ''

    smtp: Partial<AdminSmtpSettings> = { port: 587 }
    smtpLoading = true
    smtpSaving = false
    smtpTesting = false
    smtpMessage = ''
    smtpError = ''
    sigTab: 'visual' | 'code' = 'visual'

    @ViewChild('sigEditor') sigEditorRef: ElementRef<HTMLDivElement>

    constructor(
        private prospecting: ProspectingService,
        public authService: AuthenticationService,
    ) {}

    ngOnInit(): void {
        const user = this.authService.user
        this.userName = user?.displayName || ''
        this.userEmail = user?.email || ''
        this.loadSmtp()
    }

    private loadSmtp(): void {
        const uid = this.authService.user?.uid
        if (!uid) {
            this.smtpLoading = false
            this.smtpError = 'Not authenticated'
            return
        }
        this.prospecting.getSmtpSettings(uid).subscribe({
            next: (settings) => {
                if (settings) {
                    this.smtp = { ...settings }
                }
                this.smtpLoading = false
            },
            error: () => {
                this.smtpLoading = false
            },
        })
    }

    async saveSmtp(): Promise<void> {
        this.smtpMessage = ''
        this.smtpError = ''
        const uid = this.authService.user?.uid
        if (!uid) {
            this.smtpError = 'Not authenticated'
            return
        }
        this.smtpSaving = true
        try {
            await this.prospecting.saveSmtpSettings(uid, this.smtp)
            this.smtpMessage = 'SMTP settings saved'
        } catch (e: any) {
            this.smtpError = e?.message || 'Failed to save'
        } finally {
            this.smtpSaving = false
        }
    }

    async testSmtp(): Promise<void> {
        this.smtpMessage = ''
        this.smtpError = ''
        this.smtpTesting = true
        try {
            await this.prospecting.testSmtpConnection()
            this.smtpMessage = 'Connection successful!'
        } catch (e: any) {
            this.smtpError = e?.message || 'Connection test failed'
        } finally {
            this.smtpTesting = false
        }
    }

    onSigInput(): void {
        if (this.sigEditorRef?.nativeElement) {
            this.smtp.signature = this.sigEditorRef.nativeElement.innerHTML
        }
    }

    switchToCode(): void {
        if (this.sigEditorRef?.nativeElement) {
            this.smtp.signature = this.sigEditorRef.nativeElement.innerHTML
        }
        this.sigTab = 'code'
    }

    switchToVisual(): void {
        this.sigTab = 'visual'
        setTimeout(() => {
            if (this.sigEditorRef?.nativeElement) {
                this.sigEditorRef.nativeElement.innerHTML = this.smtp.signature || ''
            }
        })
    }

    onSigCodeChange(value: string): void {
        this.smtp.signature = value
    }
}
